module.exports = __webpack_public_path__ + "static/uswithchester-da7292f0599f199512db7d1c1c7d64f1.jpg";